export const hmsToSecondsOnly = function(str) {
	var p = str.split(':'),
		s = 0, m = 1;

	while (p.length > 0) {
		s += m * parseInt(p.pop(), 10);
		m *= 60;
	}

	return s;
}

export function makeSafeForCSS(str) {
  let safeString = str.replace(/[^a-zA-Z0-9_-]+/g, '-').toLowerCase();

  // Remove leading hyphens
  safeString = safeString.replace(/^-+/, '');

  // Ensure it doesn't start with a digit or a hyphen followed by a digit
  if (/^[\d-]/.test(safeString)) {
    safeString = '_' + safeString;
  }

  // Ensure it's not empty
  if (!safeString) {
    safeString = '_';
  }

  return safeString;
}